import apiService from "./apiServices";


export const createGeneralPartyInfo = async (formData, token) => {
  try {
    const headers = {

    };
    const response = await apiService('/generalPartyInfo/', 'POST', formData, headers, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Creating organization is failed. Please try again.');
  }
}

export const updateGeneralPartyInfo = async (formData, token) => {

  try {
    const headers = {

    };
    const response = await apiService('/generalPartyInfo/', 'PUT', formData, headers, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Updating organization is failed. Please try again.');
  }
}

export const getGeneralPartyInfoById = async (quoteId, token) => {
  try {
    // const headers = {
    //
    // };
    const response = await apiService(`/generalPartyInfo/${quoteId}`, 'GET', null, {}, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const getComparisionById = async (gpId, token) => {
  try {
    const headers = {

    };
    const response = await apiService(`/comparison/json/${gpId}`, 'GET', null, headers, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const getComparisionCombined = async (gpId, token) => {
  try {
    const headers = {

    };
    const response = await apiService(`/comparison/companies/${gpId}`, 'GET', null, headers, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const getPostGeneralPartyInfoById = async (id, token) => {
  try {
    const headers = {

    };
    const response = await apiService('/generalPartyInfo/fetch', 'POST', id, headers, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const getAllGeneralPartyInfo = async (token) => {
  try {
    const headers = {

    };
    const response = await apiService('/generalPartyInfo/', 'GET', null, headers, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'service is failed. Please try again.');
  }
}

export const getPriorInsuranceCarriers = async (token) => {
  try {
    const response = await apiService('/prior-carrier/', 'GET', null, null, token);
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch prior insurance carriers. Please try again.');
  }
};

export const getCityAndAddressByZipCode = async (zipCode,token) => {
  try {
    const response = await apiService(`/locale?zip=${zipCode}`, 'GET', null, null,token );
    return response;
  } catch (error) {
    throw new Error(error.message || 'Failed to fetch city and address. Please try again.');
  }
};

export const getQuoteInfoByFieldServices = async (firstName,LastName,dob,cellphone, token) => {

  try {
    const response = await apiService(`/generalPartyInfo/NameAndDob/${firstName}/${LastName}/${dob}/${cellphone}`, 'GET', null, null,token );
    return response;
  } catch (error) {
    throw new Error(error.message || 'Quote detail service is failed. Please try again.');
  }
}

export const getNewQuoteByGpidServices = async (gpId, token) => {

  try {
    const response = await apiService(`/generalPartyInfo/load/${gpId}`, 'GET', null, null,token );
    return response;
  } catch (error) {
    throw new Error(error.message || 'Quote detail service is failed. Please try again.');
  }
}

